import { Navigate, Route, Routes } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen";
import { useDesignSystem } from "../context/designSystemContext";
import { useTenant } from "../context/tenantContext";
import { RegisterCategories } from "../pages/addCategories";
import { Home } from "../pages/home";
import { Indicators } from "../pages/indicators";
import { RiskThemePage } from "../pages/riskTheme";
import { Settings } from "../pages/settings";
import { TenantSelection } from "../pages/tenantSelection";
import { ProtectedLayout } from "./ProtectedLayout";

export const AppRoutes = () => {
  const { loading: isLoadingDesignSystem } = useDesignSystem();
  const { isLoading: isLoadingTenant, selectedTenant } = useTenant();

  const shouldShowLoading =
    (isLoadingDesignSystem && selectedTenant) ||
    (isLoadingTenant && !selectedTenant);

  return (
    <>
      {shouldShowLoading ? (
        <LoadingScreen />
      ) : (
        <Routes>
          <Route path="/tenant-selection" element={<TenantSelection />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/add_risk" element={<RegisterCategories />} />
            <Route path="/risk_theme/:id" element={<RiskThemePage />} />
            <Route path="/indicators" element={<Indicators />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </>
  );
};
